import { Fragment, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import type { PopupPropsApi } from '@/common/components/popup/models'
import Popup from '@/common/components/popup/Popup'
import { useInitialData } from '@/common/hooks/useInitialData'
import { matchesUrl } from '@/common/utils/matchUrls'

const findActivePopupIndex = (popups: PopupPropsApi[], pathname: string) =>
    popups.findIndex(item => item.applicablePages?.some(page => matchesUrl(page, pathname)))

const Popups = () => {
    const location = useLocation()
    const { popups = [] } = useInitialData()

    const activePopIndex = useMemo(() => findActivePopupIndex(popups, location.pathname), [location.pathname, popups])

    return (
        <>
            {popups.map((popup, index) => (
                <Fragment key={index}>{activePopIndex === index ? <Popup id={index} {...popup} /> : null}</Fragment>
            ))}
        </>
    )
}

export default Popups
